import React, { useEffect, useState } from "react";
import { collection, getDocs, doc, deleteDoc, updateDoc } from "firebase/firestore";
import { db } from "../firebase";
import { Link } from "react-router-dom";

const OrdersList = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOrders = async () => {
      const querySnapshot = await getDocs(collection(db, "orders"));
      const ordersData = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setOrders(ordersData);
      setLoading(false);
    };
    fetchOrders();
  }, []);

  const handleDelete = async (id) => {
    if (window.confirm("هل أنت متأكد من حذف هذا الطلب؟")) {
      await deleteDoc(doc(db, "orders", id));
      setOrders(orders.filter((order) => order.id !== id));
    }
  };

  const handleStatusChange = async (id, status) => {
    const orderRef = doc(db, "orders", id);
    await updateDoc(orderRef, { status });
    setOrders(orders.map((o) => (o.id === id ? { ...o, status } : o)));
  };

  if (loading) return <p style={styles.loading}>⏳ جاري تحميل الطلبات...</p>;

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>📦 قائمة الطلبات</h2>
      <div style={styles.tableWrapper}>
        <table style={styles.table}>
          <thead>
            <tr style={styles.headerRow}>
              <th>رقم الطلب</th>
              <th>اسم العميل</th>
              <th>رقم الهاتف</th>
              <th>المنتجات</th>
              <th>الإجمالي</th>
              <th>الحالة</th>
              <th>التحكم</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((order) => {
              const total = order.items?.reduce(
                (sum, item) => sum + (item.price * (item.quantity || 1)),
                0
              ) || 0;

              return (
                <tr key={order.id} style={styles.row}>
                  <td>
                    <Link
                      to={`/admin/orders/${order.id}`}
                      style={styles.link}
                    >
                      {order.id}
                    </Link>
                  </td>
                  <td>{order.customer?.name || "-"}</td>
                  <td>{order.customer?.phone || "-"}</td>
                  <td>
                    {order.items?.map((item) => (
                      <div key={item.id} style={{ marginBottom: "4px" }}>
                        {item.name} x {item.quantity || 1}
                      </div>
                    )) || "-"}
                  </td>
                  <td>{total} ج.م</td>
                  <td>
                    <select
                      value={order.status || "جديد"}
                      onChange={(e) => handleStatusChange(order.id, e.target.value)}
                      style={styles.select}
                    >
                      <option value="جديد">🆕 جديد</option>
                      <option value="قيد التنفيذ">⏳ قيد التنفيذ</option>
                      <option value="تم التسليم">✅ تم التسليم</option>
                      <option value="ملغي">❌ ملغي</option>
                    </select>
                  </td>
                  <td>
                    <button style={styles.deleteBtn} onClick={() => handleDelete(order.id)}>
                      🗑️ حذف
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const styles = {
  container: {
    background: "#f9f9f9",
    padding: "30px",
    borderRadius: "12px",
    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
    fontFamily: "Tahoma, sans-serif",
    direction: "rtl",
    maxWidth: "1200px",
    margin: "30px auto",
    textAlign:"center",
  },
  title: {
    fontSize: "24px",
    marginBottom: "20px",
    textAlign: "center",
    color: "#333",
  },
  tableWrapper: {
    overflowX: "auto",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    backgroundColor: "#fff",
  },
  headerRow: {
    backgroundColor: "#e2e8f0",
    color: "#1a202c",
  },
  row: {
    borderBottom: "1px solid #eee",
    transition: "background 0.3s",
  },
  link: {
    textDecoration: "none",
    color: "#2563eb",
    fontWeight: "bold",
  },
  select: {
    padding: "6px 10px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    backgroundColor: "#f1f5f9",
  },
  deleteBtn: {
    backgroundColor: "#ef4444",
    color: "#fff",
    border: "none",
    padding: "6px 12px",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "bold",
  },
  loading: {
    textAlign: "center",
    fontSize: "18px",
    marginTop: "50px",
  },
};

export default OrdersList;
